import * as _ from 'lodash';

function convert(str) {
  if (_.isObject(str)) {
    return JSON.stringify(str);
  }

  return str;
}
/**
 * 原始版本 hashcode
 * @param  {[type]} str [description]
 * @return {[type]}   [description]
 */


function hashCode(str) {
  str = convert(str);
  var hash = 0;

  for (var i = 0; i < str.length; i++) {
    var _char = str.charCodeAt(i);

    hash = (hash << 5) - hash + _char;
    hash &= hash;
  }

  return hash;
}
/**
 * this algorithm (k=33) was first reported by dan bernstein many years ago in comp.lang.c.
 * another version of this algorithm (now favored by bernstein) uses xor: hash(i) = hash(i - 1) * 33 ^ str[i];
 * the magic of number 33 (why it works better than many other constants, prime or not) has never been adequately explained.
 * @param  {[type]} str [description]
 * @return {[type]}   [description]
 */


function djb2Code(str) {
  str = convert(str);
  var hash = 5381;

  for (var i = 0; i < str.length; i++) {
    var _char2 = str.charCodeAt(i);

    hash = (hash << 5) + hash + _char2;
  }

  return hash;
}
/**
 * this algorithm was created for sdbm (a public-domain reimplementation of ndbm) database library.
 * it was found to do well in scrambling bits, causing better distribution of the keys and fewer splits.
 * it also happens to be a good general hashing function with good distribution.
 * the actual function is hash(i) = hash(i - 1) * 65599 + str[i]; what is included below is the faster version used in gawk. [there is even a faster, duff-device version] the magic constant 65599 was picked out of thin air while experimenting with different constants, and turns out to be a prime.
 * this is one of the algorithms used in berkeley db (see sleepycat) and elsewhere.
 * @param  {[type]} str [description]
 * @return {[type]}   [description]
 */


function sdbmCode(str) {
  str = convert(str);
  var hash = 0;

  for (var i = 0; i < str.length; i++) {
    var _char3 = str.charCodeAt(i);

    hash = _char3 + (hash << 6) + (hash << 16) - hash;
  }

  return hash;
}
/**
 * This is an understatement; It is a terrible hashing algorithm, and it could have been much better without sacrificing its "extreme simplicity."
 * [see the second edition!] Many C programmers use this function without actually testing it, or checking something like Knuth's Sorting and Searching, so it stuck.
 * It is now found mixed with otherwise respectable code, eg. cnews. sigh.
 * @param  {[type]} str [description]
 * @return {[type]}   [description]
 */


function loseCode(str) {
  str = convert(str);
  var hash = 0;

  for (var i = 0; i < str.length; i++) {
    var _char4 = str.charCodeAt(i);

    hash += _char4;
  }

  return hash;
}

export default {
  hashCode: hashCode,
  djb2Code: djb2Code,
  sdbmCode: sdbmCode,
  loseCode: loseCode
};